import { defineMessages } from "react-intl"

export const conditionAndServiceFieldMessages = defineMessages({
	accidentDescriptionLabel: {
		defaultMessage: "Additional description of the damages or accidents",
		id: "conditionAndHistory.accident.description.descriptionText",
	},
	accidentFreeLabel: {
		defaultMessage: "Accident free",
		id: "vehicle.condition.accidentFree",
	},
	actualCostsLabel: {
		defaultMessage: "Actual costs",
		id: "conditionAndHistory.reconditioning.actualCosts.label",
	},
	approximatedCostsLabel: {
		defaultMessage: "Approximated costs",
		id: "conditionAndHistory.reconditioning.approximatedCosts.label",
	},
	batteryCapacityDateDescription: {
		defaultMessage: "The measurement should not be older than 6 months",
		id: "conditionAndHistory.reconditioning.batteryCapacityDate.description",
	},
	batteryCapacityDateLabel: {
		defaultMessage: "Date of measurement",
		id: "conditionAndHistory.reconditioning.batteryCapacityDate.label",
	},
	batteryCapacityDescription: {
		defaultMessage:
			"Please only enter a State of Health (SoH) value determined using an approved Porsche measurement method (SoH Certificate without preparation, SoH Certificate with preparation, or SoH In-Car Display). The accuracy of the measurement is ±5%.",
		id: "conditionAndHistory.reconditioning.batteryCapacity.description",
	},
	batteryCapacityLabel: {
		defaultMessage: "Battery Health (SoH)",
		id: "conditionAndHistory.reconditioning.batteryCapacity.label",
	},
	batteryCapacityMileageLabel: {
		defaultMessage: "Mileage at measurement",
		id: "conditionAndHistory.reconditioning.batteryCapacityMileage.label",
	},
	carPassUrlLabel: {
		defaultMessage: "Car-Pass URL",
		id: "conditionAndHistory.carPass.url.label",
	},
	firstRegistrationDateLabel: {
		defaultMessage: "First registration date",
		id: "conditionAndHistory.firstRegistrationDate.label",
	},
	formerRentalCarLabel: {
		defaultMessage: "Former rental car",
		id: "conditionAndHistory.formerRentalCar.label",
	},
	fullServiceHistoryInPorscheCenterLabel: {
		defaultMessage: "Yes, every service done in Porsche Center",
		id: "conditionAndHistory.fullServiceHistoryInPorscheCenter.label",
	},
	fullServiceHistoryLabel: {
		defaultMessage: "Full service history",
		id: "conditionAndHistory.fullServiceHistory.label",
	},
	knownAccidentsLabel: {
		defaultMessage: "Known previous damages or accidents",
		id: "vehicle.condition.knownAccidents",
	},
	latestMaintenanceDateTitle: {
		defaultMessage: "Latest maintenance",
		id: "vehicle.latestMaintenanceDate",
	},
	latestMaintenanceMileageLabel: {
		defaultMessage: "Mileage at latest maintenance",
		id: "vehicle.latestMaintenanceMileage",
	},
	latestMaintenanceScopeDescription: {
		defaultMessage: "Select the same maintenance categories that are used in PCSS",
		id: "conditionAndHistory.latestMaintenance.scope.description",
	},
	latestMaintenanceScopeLabel: {
		defaultMessage: "Maintenance scope",
		id: "conditionAndHistory.latestMaintenance.scope.label",
	},
	latestMaintenanceWorkshopLabel: {
		defaultMessage: "Workshop name",
		id: "conditionAndHistory.latestMaintenance.workshop.label",
	},
	mileageLabel: {
		defaultMessage: "Mileage",
		id: "conditionAndHistory.mileage.label",
	},
	newOnSaleLabel: {
		defaultMessage: "New general inspection on sale",
		id: "vehicle.renewGeneralInspectionOnSale",
	},
	nextGeneralInspectionDateLabel: {
		defaultMessage: "Next General Inspection",
		id: "conditionAndHistory.nextGeneralInspection.label",
	},
	nonSmokerLabel: {
		defaultMessage: "Nonsmoker",
		id: "conditionAndHistory.nonSmoker.label",
	},
	previousDamageAmountLabel: {
		defaultMessage: "Amount",
		id: "conditionAndHistory.previousDamage.amount.label",
	},
	previousDamageDescriptionLabel: {
		defaultMessage: "Description",
		id: "conditionAndHistory.previousDamage.description.label",
	},
	previousDamageLabel: {
		defaultMessage: "Previous damages",
		id: "conditionAndHistory.previousDamage.label",
	},
	previousOwnersLabel: {
		defaultMessage: "Previous owners",
		id: "conditionAndHistory.previousOwners.label",
	},
	previousOwnerUsageHistoryLabel: {
		defaultMessage: "Previous owner usage history",
		id: "conditionAndHistory.previousOwnerUsageHistory.label",
	},
	reconditioningLabel: {
		defaultMessage: "Reconditioning",
		id: "conditionAndHistory.reconditioning.label",
	},
})
